import Litepicker from "litepicker";
import moment from "moment";
import React from "react";
import ReactDOM from "react-dom/client";
import DateRangePicker from "./dateRangePicker";
import { formatDateLocale } from "../../../../infrastructure/utils/formatDateLocale";
const LitePickerComponent = ({ setEndDate, setStartDate, setShowDateModal, startDate, endDate, footerHtml, setFooterHtml, formatDate, t, setTrigger }) => {
    let picker = null;
    let currentMode = window.innerWidth > 999 ? 'desktop' : 'mobile';
    let mobilePickerRoot = null;
    const renderMobilePicker = () => {
        const modalBody = document.getElementById("body-modal");
        if (!modalBody)
            return;
        // Create a container for the React DateRangePicker if it doesn't exist
        let container = document.getElementById("react-date-range-picker");
        if (!container) {
            container = document.createElement("div");
            container.id = "react-date-range-picker";
            modalBody.appendChild(container);
        }
        if (!mobilePickerRoot) {
            mobilePickerRoot = ReactDOM.createRoot(container);
        }
        mobilePickerRoot.render(React.createElement(DateRangePicker, {
            startDate,
            endDate,
            setStartDate,
            setEndDate,
            setShowDateModal,
            setFooterHtml,
            formatDate,
            t,
            setTrigger,
        }));
    };
    const destroyMobilePicker = () => {
        if (mobilePickerRoot) {
            mobilePickerRoot.unmount();
            mobilePickerRoot = null;
        }
        const container = document.getElementById("react-date-range-picker");
        if (container) {
            container.remove();
        }
    };
    const initPicker = () => {
        if (picker) {
            picker.destroy();
        }
        // Mobile: use react-day-picker instead of Litepicker
        if (window.innerWidth < 999) {
            initMobileMode();
            return;
        }
        // Desktop: use Litepicker as before
        destroyMobilePicker();
        initDesktopPicker();
    };
    const initMobileMode = () => {
        // Setup pickup/return button handlers for mobile
        const handlePickupDatePickerClick = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (window.innerWidth < 999) {
                setShowDateModal(true);
                const mainDateBody = document.querySelector(".container__main");
                mainDateBody === null || mainDateBody === void 0 ? void 0 : mainDateBody.classList.add("hidden");
                (_a = document.querySelector(".header")) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
                (_b = document.querySelector("body")) === null || _b === void 0 ? void 0 : _b.classList.add("noscroll");
                (_c = document.querySelector(".search_bg")) === null || _c === void 0 ? void 0 : _c.classList.add("open");
                (_d = document.querySelector("#chat")) === null || _d === void 0 ? void 0 : _d.classList.add("hidden");
                (_e = document.querySelector(".searchbar")) === null || _e === void 0 ? void 0 : _e.classList.add("hidden");
                (_f = document.querySelector(".sticky_main_div")) === null || _f === void 0 ? void 0 : _f.classList.add("hidden");
                (_g = document.querySelector(".logolistfix")) === null || _g === void 0 ? void 0 : _g.classList.add("hidden");
                (_h = document.querySelector("#help_label_chat")) === null || _h === void 0 ? void 0 : _h.classList.add("hidden");
                (_j = document.querySelector(".right_side_logo")) === null || _j === void 0 ? void 0 : _j.classList.add("hidden");
                (_k = document.querySelector(".banner__content")) === null || _k === void 0 ? void 0 : _k.classList.add("hidden");
                setTimeout(() => {
                    renderMobilePicker();
                    mainDateBody === null || mainDateBody === void 0 ? void 0 : mainDateBody.classList.remove("hidden");
                }, 100);
            }
        };
        const handleReturnDatePickerClick = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (window.innerWidth < 999) {
                setShowDateModal(true);
                const mainDateBody = document.querySelector(".container__main");
                mainDateBody === null || mainDateBody === void 0 ? void 0 : mainDateBody.classList.add("hidden");
                (_a = document.querySelector(".header")) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
                (_b = document.querySelector("body")) === null || _b === void 0 ? void 0 : _b.classList.add("noscroll");
                (_c = document.querySelector(".search_bg")) === null || _c === void 0 ? void 0 : _c.classList.add("open");
                (_d = document.querySelector(".searchbar ")) === null || _d === void 0 ? void 0 : _d.classList.add("hidden");
                (_e = document.getElementsByClassName(".logo_list")[1]) === null || _e === void 0 ? void 0 : _e.classList.add("hidden");
                (_f = document.querySelector(".sticky_main_div")) === null || _f === void 0 ? void 0 : _f.classList.add("hidden");
                (_g = document.querySelector(".logolistfix")) === null || _g === void 0 ? void 0 : _g.classList.add("hidden");
                (_h = document.querySelector("#help_label_chat")) === null || _h === void 0 ? void 0 : _h.classList.add("hidden");
                (_j = document.querySelector(".right_side_logo")) === null || _j === void 0 ? void 0 : _j.classList.add("hidden");
                (_k = document.querySelector(".banner__content")) === null || _k === void 0 ? void 0 : _k.classList.add("hidden");
                setTimeout(() => {
                    renderMobilePicker();
                    mainDateBody === null || mainDateBody === void 0 ? void 0 : mainDateBody.classList.remove("hidden");
                }, 100);
            }
        };
        const pickupDatePicker = document.querySelector("#pickup_date_picker");
        pickupDatePicker === null || pickupDatePicker === void 0 ? void 0 : pickupDatePicker.addEventListener("click", handlePickupDatePickerClick);
        const returnDatePicker = document.querySelector("#return_date_picker");
        returnDatePicker === null || returnDatePicker === void 0 ? void 0 : returnDatePicker.addEventListener("click", handleReturnDatePickerClick);
    };
    const initDesktopPicker = () => {
        let remonths = 0;
        let date1uuuuu = [];
        let date2uuuuu = null;
        let messaggeCtrl = 0;
        const startElement = document.getElementById("start");
        const endElement = document.getElementById("end");
        picker = new Litepicker({
            element: startElement,
            elementEnd: endElement,
            singleMode: false,
            autoRefresh: true,
            numberOfMonths: 2,
            numberOfColumns: 2,
            autoApply: true,
            allowRepick: false,
            showWeekNumbers: false,
            showTooltip: true,
            lang: t("locale"),
            buttonText: {
                apply: t("button-apply"),
                cancel: t("cancel-button"),
                nextMonth: '<svg width="12" height="12px" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>',
                previousMonth: '<svg width="12" height="12px" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>',
                reset: "Reiniciar",
            },
            tooltipNumber: (totalDays) => totalDays - 1,
            tooltipText: { one: t("day"), other: t("days") },
            minDate: moment().add(1, "days").toDate(),
            startDate: moment(startDate[1]).toDate(),
            endDate: moment(endDate[1]).toDate(),
            format: {
                parse(date) {
                    if (date instanceof Date)
                        return date;
                    return moment(date, ['MMM DD', 'MMM D', 'MMMM DD', 'MMMM D'], true).toDate();
                },
                // WI #8606: replaced moment + destructive .replace() chain with
                // formatDateLocale. The old chain corrupted accented characters.
                output(date) {
                    return formatDateLocale(date instanceof Date ? date : new Date(date), t("locale") || "en");
                }
            },
            setup: (picker) => {
                picker.on("show", () => {
                    const litepicker = document.querySelector('.litepicker');
                    const startInput = document.getElementById('start');
                    const endInput = document.getElementById('end');
                    if (litepicker && (startInput || endInput)) {
                        const viewport = window.innerHeight;
                        const pickerHeight = litepicker.offsetHeight;
                        const activeInput = document.activeElement;
                        const inputRect = (activeInput === endInput ? endInput : startInput).getBoundingClientRect();
                        if (viewport - inputRect.bottom < pickerHeight) {
                            litepicker.style.top = `${inputRect.top - pickerHeight - 10}px`;
                            litepicker.classList.add('litepicker-above');
                        }
                        else {
                            litepicker.classList.remove('litepicker-above');
                        }
                    }
                    date1uuuuu = [];
                    date2uuuuu = null;
                    remonths = 0;
                    setTimeout(function () {
                        var _a, _b, _c, _d;
                        let startDateSpan = document.querySelector(".preview-date-range");
                        if (startDateSpan) {
                            startDateSpan.innerHTML = footerHtml;
                            let startDateSpan1 = document.querySelector(".js-start-date");
                            let endDateSpan = document.querySelector(".js-end-date");
                            if (startDateSpan1 && endDateSpan) {
                                startDateSpan1.textContent = (_a = document.getElementById("start")) === null || _a === void 0 ? void 0 : _a.value;
                                endDateSpan.textContent = (_b = document.getElementById("end")) === null || _b === void 0 ? void 0 : _b.value;
                                startDateSpan1.innerHTML = (_c = document.getElementById("start")) === null || _c === void 0 ? void 0 : _c.value;
                                endDateSpan.innerHTML = (_d = document.getElementById("end")) === null || _d === void 0 ? void 0 : _d.value;
                            }
                        }
                    }, 100);
                });
                picker.on("preselect", (date1, date2) => {
                    var _a, _b;
                    date1uuuuu = [formatDate(date1["dateInstance"]) || "", "" + moment(date1["dateInstance"]).format("YYYY-MM-DD")];
                    if (date2 != undefined && date2 != null) {
                        date2uuuuu = [formatDate(date2["dateInstance"]) || "", "" + moment(date2["dateInstance"]).format("YYYY-MM-DD")];
                    }
                    let startDateSpan = document.querySelector(".preview-date-range");
                    if (date1 != null && date2 == undefined) {
                        (_a = document.getElementsByClassName("is-start-date")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("fullborders");
                        if (startDateSpan) {
                            startDateSpan.innerHTML = messaggeCtrl === 1 ? `<span> ${t("select_first_date")} </span>` : `<span> ${t("select_second_date")} </span>`;
                        }
                    }
                    if (date1 != null && date2 != null) {
                        if (startDateSpan) {
                            startDateSpan.innerHTML = `
                <span class="js-start-date start-date">${formatDate(date1["dateInstance"]) || ""}</span>
                <span> - </span>
                <span class="js-end-date end-date" id="endDateBar">${formatDate(date2["dateInstance"]) || ""}</span>
              `;
                        }
                        (_b = document.getElementsByClassName("is-start-date")[0]) === null || _b === void 0 ? void 0 : _b.classList.remove("fullborders");
                    }
                });
                picker.on("render:day", (day, date) => {
                    day.innerHTML = `<div class="range_ball">${date.format("DD")}</div>`;
                    const today = new Date();
                    const formattedToday = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
                    if (date.format("YYYY-MM-DD") === formattedToday)
                        day.classList.add("today_day");
                    if (date.getDay() === 1)
                        day.classList.add("monday");
                    if (date.getDay() === 0)
                        day.classList.add("friday");
                });
                picker.on("before:render", () => {
                    setTimeout(function () {
                        const litepickerElement = document.querySelector(".litepicker");
                        litepickerElement === null || litepickerElement === void 0 ? void 0 : litepickerElement.classList.add("desktop_date_picker");
                    }, 50);
                });
                picker.on("selected", (start, end) => {
                    var _a, _b;
                    date1uuuuu = [formatDate(start["dateInstance"]) || "", "" + moment(start["dateInstance"]).format("YYYY-MM-DD")];
                    date2uuuuu = [formatDate(end["dateInstance"]) || "", "" + moment(end["dateInstance"]).format("YYYY-MM-DD")];
                    setFooterHtml(`
            <span class="js-start-date start-date">${formatDate(start["dateInstance"]) || ""}</span>
            <span> - </span>
            <span class="js-end-date end-date" id="endDateBar">${formatDate(end["dateInstance"]) || ""}</span>
          `);
                    (_a = document.getElementById("start")) === null || _a === void 0 ? void 0 : _a.classList.add("selected");
                    (_b = document.getElementById("end")) === null || _b === void 0 ? void 0 : _b.classList.add("selected");
                    setStartDate([formatDate(start["dateInstance"]) || "", "" + moment(start["dateInstance"]).format("YYYY-MM-DD")]);
                    setEndDate([formatDate(end["dateInstance"]) || "", "" + moment(end["dateInstance"]).format("YYYY-MM-DD")]);
                    if (sessionStorage.getItem("preloadSearchStarted") == "true")
                        setTrigger(Math.floor(Math.random() * 5000) + 1);
                    let startDateSpan = document.querySelector(".js-start-date");
                    let endDateSpan = document.querySelector(".js-end-date");
                    if (startDateSpan && endDateSpan) {
                        startDateSpan.textContent = formatDate(start["dateInstance"]);
                        endDateSpan.textContent = formatDate(end["dateInstance"]);
                        startDateSpan.innerHTML = formatDate(start["dateInstance"]);
                        endDateSpan.innerHTML = formatDate(end["dateInstance"]);
                    }
                });
                picker.on("hide", () => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    setShowDateModal(false);
                    (_a = document.querySelector(".header")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
                    document.body.classList.remove("noscroll");
                    (_b = document.querySelector(".search_bg")) === null || _b === void 0 ? void 0 : _b.classList.remove("open");
                    (_c = document.querySelector(".searchbar")) === null || _c === void 0 ? void 0 : _c.classList.remove("hidden");
                    (_d = document.getElementsByClassName("shopify-section-group-header-group")[0]) === null || _d === void 0 ? void 0 : _d.classList.remove("hidden");
                    (_e = document.getElementsByClassName("header-wrapper")[0]) === null || _e === void 0 ? void 0 : _e.classList.remove("hidden");
                    (_f = document.querySelector(".sticky_main_div")) === null || _f === void 0 ? void 0 : _f.classList.remove("hidden");
                    (_g = document.querySelector(".logolistfix")) === null || _g === void 0 ? void 0 : _g.classList.remove("hidden");
                    (_h = document.querySelector("#help_label_chat")) === null || _h === void 0 ? void 0 : _h.classList.remove("hidden");
                    (_j = document.querySelector(".right_side_logo")) === null || _j === void 0 ? void 0 : _j.classList.remove("hidden");
                    (_k = document.querySelector(".banner__content")) === null || _k === void 0 ? void 0 : _k.classList.remove("hidden");
                });
            },
        });
        // Scroll guard for mobile — prevents touch-scroll from triggering day-item clicks
        if (window.innerWidth < 999) {
            const popup = document.querySelector('#date-picker-modal .popup');
            if (popup) {
                let isScrolling = false;
                let startY = 0;
                let scrollTimer = null;
                popup.addEventListener('touchstart', (e) => {
                    startY = e.touches[0].clientY;
                    isScrolling = false;
                    if (scrollTimer)
                        clearTimeout(scrollTimer);
                }, { passive: true });
                popup.addEventListener('touchmove', (e) => {
                    if (Math.abs(e.touches[0].clientY - startY) > 10) {
                        isScrolling = true;
                    }
                }, { passive: true });
                popup.addEventListener('touchend', () => {
                    scrollTimer = setTimeout(() => {
                        isScrolling = false;
                    }, 100);
                }, { passive: true });
                popup.addEventListener('click', (e) => {
                    var _a;
                    if (isScrolling && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.day-item'))) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }, true); // capture phase
            }
        }
        // Scroll guard for mobile — prevents touch-scroll from triggering day-item clicks
        if (window.innerWidth < 999) {
            const popup = document.querySelector('#date-picker-modal .popup');
            if (popup) {
                let isScrolling = false;
                let startY = 0;
                let scrollTimer = null;
                popup.addEventListener('touchstart', (e) => {
                    startY = e.touches[0].clientY;
                    isScrolling = false;
                    if (scrollTimer)
                        clearTimeout(scrollTimer);
                }, { passive: true });
                popup.addEventListener('touchmove', (e) => {
                    if (Math.abs(e.touches[0].clientY - startY) > 10) {
                        isScrolling = true;
                    }
                }, { passive: true });
                popup.addEventListener('touchend', () => {
                    scrollTimer = setTimeout(() => {
                        isScrolling = false;
                    }, 100);
                }, { passive: true });
                popup.addEventListener('click', (e) => {
                    var _a;
                    if (isScrolling && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.day-item'))) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }, true); // capture phase
            }
        }
        // Desktop-only: Pickup and return buttons
        const handlePickupDatePickerClick = () => {
            messaggeCtrl = 0;
        };
        const handleReturnDatePickerClick = () => {
            messaggeCtrl = 1;
        };
        const pickupDatePicker = document.querySelector("#pickup_date_picker");
        pickupDatePicker === null || pickupDatePicker === void 0 ? void 0 : pickupDatePicker.addEventListener("click", handlePickupDatePickerClick);
        const returnDatePicker = document.querySelector("#return_date_picker");
        returnDatePicker === null || returnDatePicker === void 0 ? void 0 : returnDatePicker.addEventListener("click", handleReturnDatePickerClick);
        startElement.addEventListener("click", () => {
            if (window.innerWidth > 999)
                picker === null || picker === void 0 ? void 0 : picker.setOptions({ allowRepick: false });
        });
        endElement.addEventListener("click", () => {
            if (window.innerWidth > 999)
                picker === null || picker === void 0 ? void 0 : picker.setOptions({ allowRepick: true });
            picker === null || picker === void 0 ? void 0 : picker.gotoDate(picker.getEndDate());
        });
    };
    // === Initialize ===
    initPicker();
    // === Listen for window resize and reinitialize if crossing threshold ===
    window.addEventListener('resize', () => {
        const newMode = window.innerWidth > 999 ? 'desktop' : 'mobile';
        if (newMode !== currentMode) {
            currentMode = newMode;
            if (newMode === 'desktop') {
                destroyMobilePicker();
            }
            initPicker();
        }
    });
};
export default LitePickerComponent;
